var $ = require('jquery');
var Masonry = require('masonry-layout');
import '../../../core/static/js/lib/modernizr-custom.min-9.js'
import '../../../core/static/js/lib/flickity.pkgd.min.js'
import Rellax from '../../../core/static/js/lib/rellax.min.js'
import Flickity from '../../../core/static/js/lib/flickity.pkgd.min.js'
import { ripples } from '../../../core/static/js/lib/jquery.ripples-min.js'

window.jQuery = $;
window.$ = $;
window.Masonry = Masonry;
window.Rellax = Rellax;
window.Flickity = Flickity;
window.ripples = ripples